//slide z-index contstants
export const SUPPORT_SLIDE_ZINDEX = {
  slide: "z-10",
  header: "z-20",
};
